import {
    registerAsset,
    AssetAriaLabel,
    LEGACY_DEFAULT_MIN_ASSET_WIDTH,
} from 'owa-timestream-asset-sdk';
import type { LocationPayload } from './schema';
import LocationView from './components/LocationView';
import {
    locationAssetName,
    locationAssetTooltip,
    assertErrorLocation,
} from './location.locstring.json';
import loc from 'owa-localize';
import { ControlIcons } from 'owa-control-icons';

const LOCATION_TYPE = 'location';

export default registerAsset<LocationPayload>({
    type: LOCATION_TYPE,
    iconName: ControlIcons.MapPin,
    getToolName: () => loc(locationAssetName),
    getTooltip: () => loc(locationAssetTooltip),
    getErrorMessage: () => loc(assertErrorLocation),
    unsupportedDefaultCommands: [],
    customRenderDueDate: true,
    CanvasView: LocationView,
    createEmptyAsset: () => ({
        type: LOCATION_TYPE,
        width: LEGACY_DEFAULT_MIN_ASSET_WIDTH,
        payload: { selectedLocation: undefined, locationDetails: undefined },
    }),
    getAriaLabel: (payload: LocationPayload) => {
        if (!payload.selectedLocation) {
            return loc(locationAssetName);
        }
        return loc(
            AssetAriaLabel.assetAriaLabel,
            loc(locationAssetName),
            getLocationTitle(payload)
        );
    },
    getTitleString: getLocationTitle,
    getSearchString: getLocationTitle,
});

function getLocationTitle(payload: LocationPayload) {
    return payload?.selectedLocation?.persona?.displayName;
}
